module.exports = file => () => import('../views/' + file + '.vue')



// WEBPACK FOOTER //
// ./src/router/import-production.js